import { Globe } from 'lucide-react'
import { useLanguage } from '@/hooks/useLanguage'
import { cn } from '@/lib/utils'

interface LanguageToggleProps {
  className?: string
  variant?: 'sidebar' | 'auth'
}

// Находка 7: общий слой (src/components/common) о фичах не знает — запись
// языка в профиль (auth) живёт РОВНО в одном месте, ProfileLanguageSync
// (features/auth), который сверяет язык интерфейса с профилем на каждое
// расхождение, включая расхождение, вызванное этим самым переключателем.
export const LanguageToggle = ({ className, variant = 'sidebar' }: LanguageToggleProps) => {
  const { language, setLanguage } = useLanguage()
  const next = language === 'ru' ? 'en' : 'ru'

  // white by design: 'auth' variant renders over the fixed-dark Auth hero, not app surface
  const palette =
    variant === 'auth'
      ? 'text-white/60 hover:text-white hover:bg-white/5'
      : 'text-muted-foreground hover:text-foreground hover:bg-transparent'

  return (
    <button
      type="button"
      onClick={() => setLanguage(next)}
      aria-label={language === 'ru' ? 'Switch to English' : 'Переключить на русский'}
      title={language === 'ru' ? 'Switch to English' : 'Переключить на русский'}
      className={cn(
        'inline-flex items-center gap-1.5 h-9 px-2 rounded-md text-sm font-medium transition-colors',
        palette,
        className,
      )}
    >
      <Globe className="h-5 w-5" />
      <span className="uppercase tracking-wide">{language}</span>
    </button>
  )
}
